// Models
import Model from './Model'

class ForexCurrencyRate extends Model {
  get schema () {
    return [
      'id',
      'rate',
      'alternativeRate',
      'dayMargin',
      'dayMarginEnabled',
      'nightMargin',
      'nightMarginEnabled',
      'weekendMargin',
      'weekendMarginEnabled',
      'fee',
      'enabled'
    ]
  }
}

export const CURRENCY_RATE_ACTIONS = {
  BUY: 'BUY',
  SELL: 'SELL'
}

export default ForexCurrencyRate
